import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { MatTableDataSource, MatSort, Sort, MatIconRegistry, PageEvent } from '@angular/material';
import { AdminService } from '../admin.service';
import { first } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertService } from '../../../services/alert.service';
import { ManagerUsersService } from '../manager-users.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OapErrorMessages, OapStandarErrorStateMatcher, errorMessages } from '../../custom-validators/custom-validators.module';
import { ManagerUserData, buildManagerUserData } from '../manager-users.model';

export interface SearchManagerUser {
  managerKey: null
  email: null
  lastName: null
  accountEnabled: null
}

@Component({
  selector: 'oap-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.scss']
})
export class ManageUsersComponent implements OnInit {

  searchForm: FormGroup;

  displayedColumns: string[] = ['rowId', 'identifiant', 'role', 'nom', 'prenom', 'email', 'telephone', 'actif','actions',];
  dataSource: MatTableDataSource<ManagerUserData>;
  loading = false;
  @ViewChild(MatSort) sort: MatSort;

  results: ManagerUserData[] = [];

  // information pour le paginator
  totalItems = 100;
  pageSize = 8;
  pageRequested = 1; // page for back base index 1
  pageIndex = 0; // page index paginator base index 0 
  totalPages = 1;
  pageSizeOptions: number[] = [2, 4, 8, 16];
  sortColumnName = 'LASTNAME'; // colonne à trier
  sortOrder = 'ASC'; // asc ou desc

  // MatPaginator Output
  pageEvent: PageEvent;

  matcher = new OapStandarErrorStateMatcher();
  errors = errorMessages;
  validation_messages = OapErrorMessages;

  label_only_active_account="Uniquement les comptes actifs"

  tooltip_reset_password="Reset du mot de passe";
  tooltip_edit_user="Modifier l'utilisateur";
  
  informations: string;

  viewButtonExport = false; // autorise la vue du boutton export excel
  viewPaginator = true;
  submitted = false;

  constructor(private messageService: MessageService,
    private adminService: AdminService,
    private managerUsersService: ManagerUsersService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private iconRegistry: MatIconRegistry, 
    private sanitizer: DomSanitizer) { 
      iconRegistry.addSvgIcon('edit', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-edit-24px.svg'));
      iconRegistry.addSvgIcon('add', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-add-24px.svg'));
      iconRegistry.addSvgIcon('reset', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-cached-24px.svg'));
    }

  ngOnInit() {
    this.messageService.sendMessage('page-admin');
    this.alertService.clear();

    this.searchForm = this.formBuilder.group({
      lastName: ['', Validators.maxLength(255)],
      email: ['', Validators.maxLength(255)],
      accountEnabled: ['', ]
    });

    this.clearSearchForm();
  }

  sortData(sort: Sort) {
    this.alertService.clear();
    this.sortOrder = sort.direction;

    switch (sort.active) {
      case 'identifiant':
        this.sortColumnName = 'IDENTIFIANT';
        break;
      case 'role':
        this.sortColumnName = 'ROLE';
        break;
      case 'email':
        this.sortColumnName = 'MAIL';
        break;
      case 'nom':
        this.sortColumnName = 'LASTNAME';
        break;
      default:
        this.sortColumnName = 'LASTNAME';
        break;
    }

    this.onFormSubmit(this.searchForm);
  }

  onFormSubmit(form: FormGroup) {
    this.alertService.clear();

    this.submitted = true;
    this.loading = true;
    this.viewButtonExport = false;

    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    const searchElement = this.getSearchElement();

    this.doServiceSearch(searchElement);

  }

  onPageEvent(event: PageEvent) {
    this.alertService.clear();
   
    this.pageIndex = event.pageIndex;
    this.pageRequested = this.pageIndex + 1;
    this.pageSize = event.pageSize;

    const searchElement = this.getSearchElement();

    this.submitted = true;
    this.loading = true;

    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    this.doServiceSearch(searchElement);
  }

  clearSearchForm() {
    this.searchForm.patchValue(
      {
        lastName: null,
        email: null, 
        accountEnabled: "true"
      });

    this.onFormSubmit(this.searchForm);
    this.viewButtonExport = false;
  }

  onRowClick() {
    this.alertService.clear();
  }

  onEnableUser(managerUser: ManagerUserData) {
    managerUser.actif = !managerUser.actif;
    this.managerUsersService.enable(managerUser.accountKey, managerUser.actif)
      .pipe(first())
      .subscribe(
        data => {
          this.alertService.success('Mise à jour réussie', false);
        },
        error => {
          console.error(error)
          this.alertService.error(error, true);
        });
  }

  onResetPassword(managerUserKey: number) {
    this.managerUsersService.resetPassword(managerUserKey)
      .pipe(first())
      .subscribe(
        data => {
          this.alertService.success('Réinitialisation du mot de passe réussi', false);
        },
        error => {
          console.error(error)
          this.alertService.error(error, true);
        });
  }

  private getSearchElement(): SearchManagerUser {
    return {
      managerKey: null,
      lastName: this.searchForm.controls.lastName.value === "" ? null : this.searchForm.controls.lastName.value ,
      email: this.searchForm.controls.email.value === "" ? null : this.searchForm.controls.email.value,
      accountEnabled: this.searchForm.controls.accountEnabled.value
    };
  }

  private doServiceSearch(searchManagerUser: SearchManagerUser) {
    console.log('TimezoneOffset :' + new Date().getTimezoneOffset());

    this.managerUsersService.findManagerUsers(searchManagerUser, this.pageRequested, this.pageSize, this.sortColumnName, this.sortOrder)
      .pipe(first())
      .subscribe(
        data => {
          console.log(data);

          this.pageRequested = data.pageRequested;
          this.pageIndex = data.pageRequested - 1;
          this.pageSize = data.numberOfItemsByPage;
          this.totalPages = data.numberOfPages;
          this.totalItems = data.numberOfItems;

          this.results = [];
          data.items.forEach((element: any) => {
            this.results.push(buildManagerUserData(element));
          });
          
          this.dataSource = new MatTableDataSource(this.results);

          if (this.results.length > 0) {
            this.viewButtonExport = true;
            this.viewPaginator = true;
          } else {
            this.viewButtonExport = false;
            this.viewPaginator = false;
          }

        },
        error => {
          console.error(error);
          this.alertService.error(error, true);
          this.loading = false;
          this.viewButtonExport = false;
          this.viewPaginator = false;
        },
        () => { this.loading = false; });
  }

}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
